/* eslint eqeqeq: "off" */
import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import PropTypes from "prop-types";
import {
  AutoComplete,
  Col,
  Divider,
  // Dropdown,
  Input,
  Row,
  Modal,
  Tooltip,
  Image,
  Typography,
  Skeleton,
  // Select,
  Radio,
  // Skeleton,
} from "antd";
import {
  FileTextOutlined,
  // DownOutlined,
  EditOutlined,
  ArrowDownOutlined,
  ArrowUpOutlined,
  PlusOutlined,
  DeleteOutlined,
  ArrowLeftOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import "./index.css";
import { itemSelectTabs } from "./data";
import customModalLogo from "../../assets/images/custom-field-banner.webp";
import { useHistory } from "react-router";
// import { Link } from "react-router-dom";
import { FcMoneyTransfer } from "react-icons/fc";
import Transactions from "./transaction";
import ItemWiseReport from "./itemReport";
import { isEmpty } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import {
  adjustStockList,
  loadItems,
} from "../../store/items/actions";
import { toast, ToastContainer } from "react-toastify";
import CreateItems from "./items";
import api from "../../helpers";

const ItemsSelection = (props) => {
  const [loading, setLoading] = useState(false);
  const [itemsLoading, setItemsLoading] = useState(false);

  const dispatch = useDispatch();

  // const [selectedValue, setSelectedValue] = useState("Item Details");
  //organisation id from login response
  const userName = localStorage.getItem("authData");

  const userNameDetails = JSON.parse(userName);

  const userInfoDetails = !isEmpty(userNameDetails)
    ? userNameDetails.user.organizations[0].organizationId
    : "";
  const itemListId = { organizationId: userInfoDetails };

  //items tabs

  const itemTabName =
    props.location && props.location.state ? props.location.state._id : "";

  const itemData =
    props.location && props.location.state ? props.location.state : "";
  // const recordsMetaData = props.location.state
  //   ? props.location.state.metaData
  //   : "";
  console.log(itemData, "itemData");
  //api loader
  useEffect(() => {
    dispatch(loadItems(itemListId));
    setItemsLoading(true);
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setItemsLoading(false);
    }, 2000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //Reducer state
  const { items_list = [] } = useSelector((state) => state.Items);

  //local state value
  const [createItemModal, setCreateItemModal] = useState(false);
  const [itemDetailsData, setItemDetailsData] = useState("");

  const [itemCreated, setItemCreated] = useState(false);
  const [deleteItemModal, setDeleteItemModal] = useState(false);
  const [pageRouting, setPageRouting] = useState(false);
  const [itemsTab, setItemsTab] = useState(itemTabName);
  // const [mouseEnter, setMouseEnter] = useState(false);
  const [itemsSelectedTabs, setItemsSelectedTabs] = useState("Item Details");
  const history = useHistory();

  const handleClose = (data) => {
    setCreateItemModal(data);
    console.log(data, "data");
  };

  const handleItemCreate = (data) => {
    setItemCreated(data);
    console.log(data, "data");
  };

  const [itemRows, setItemRows] = useState([
    {
      itemName: "",
      itemNameValue: "",
      itemCode: "",
      salesPrice: "",
      purchasePrice: "",
      categoryId: "",
      categoryName: "",
      brandId: "",
      brandName: "",
      stockQTY: "",
      batchDetails: "",
      createdAt: "",
      HSNCode: "",
      createdBy: "",
      customFields: "",
      gstPercentageId: "",
      image: "",
      isProduct: "",
      isService: "",
      measuringId: "",
      serialDetails: "",
      serialMeasuringId: "",
      updatedAt: "",
      _id: "",
      index: "",
      action: "",
      status: "",
    },
  ]);

  const [search, setSearch] = useState("");

  const itemHeadersTable =
    items_list && items_list.length > 0
      ? items_list.map((data, index) => {
          return {
            index: index + 1,
            itemName: data.itemName,
            itemNameValue: data.itemName,
            _id: data._id,
            HSNCode: data.HSNCode,
            itemCode:
              data.itemCode !== undefined || !isEmpty(data.itemCode)
                ? data.itemCode
                : "",
            salesPrice:
              data.salesPrice && parseFloat(data.salesPrice).toFixed(2),
            purchasePrice:
              data.purchasePrice && parseFloat(data.purchasePrice).toFixed(2),
            stockQTY: data.noofStock,
            categoryId: data.categoryId,
            categoryName: data.categoryName,
            brandId: data.brandId,
            brandName: data.brandName,
            description: data.description,
            batchDetails: data.batchDetails,
            createdAt: data.createdAt,
            createdBy: data.createdBy,
            customFields: data.customFields,
            gstPercentageId: data.gstPercentageId,
            gstPercentageName: data.gstPercentageName,
            serialMeasuringId: data.serialMeasuringId,
            serialMeasuringName: data.serialMeasuringName,
            image: data.image,
            isProduct: data.isProduct !== undefined ? data.isProduct : false,
            isService: data.isService !== undefined ? data.isService : false,
            measuringId: data.measuringId,
            serialDetails: data.serialDetails,
            // serialMeasuringId: data.serialMeasuringId,
            updatedAt: data.updatedAt,
            status: data.status,
          };
        })
      : [];

  useEffect(() => {
    if (itemHeadersTable && itemHeadersTable.length > 0 && !isEmpty(itemsTab)) {
      setItemRows(itemHeadersTable);
      const itemSelectedData =
        itemHeadersTable &&
        itemHeadersTable.filter((data) => data._id == itemsTab);
      console.log(itemSelectedData, "itemSelectedData");
      setItemDetailsData(itemSelectedData[0]);
    } else if (!isEmpty(deletedItemId)) {
      const itemSelectedData =
        itemHeadersTable &&
        itemHeadersTable.filter((data) => data._id == itemsTab);
      console.log(itemSelectedData, "itemSelectedData");
      setItemDetailsData(itemSelectedData[0]);
    }
    // else if (itemsTab === itemDetailsData.itemName) {
    //   const itemSelectedData =
    //     itemHeadersTable &&
    //     itemHeadersTable.filter((data) => data.itemName == itemsTab);
    //   console.log(itemSelectedData, "itemSelectedData");
    //   setItemDetailsData(itemSelectedData[0]);
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemsTab, items_list]);

  console.log(itemTabName, "itemTabName");
  console.log(itemHeadersTable, "itemHeadersTable");

  const updatedItemList = (data) => {
    // dispatch(loadItems(itemListId));
    setTimeout(() => {
      setItemsTab(data);
      // setTimeout(() => {
      //   const itemSelectedData =
      //     itemHeadersTable &&
      //     itemHeadersTable.filter((data) => data.itemName == itemsTab);
      //   setItemDetailsData(itemSelectedData[0]);
      // }, 1000);
    }, 2000);
    setPageRender(!pageRender);
    console.log(data, "New item Data");
  };

  const handleSearch = (event) => {
    const filteredRows = itemHeadersTable
      .filter((row) =>
        row.itemNameValue
          .toLowerCase()
          .includes(event.target.value.toLowerCase())
      )
      .filter((item, index, self) => self.indexOf(item) === index); // Remove duplicates

    setSearch(event.target.value);
    setItemRows(filteredRows);
    setItemsLoading(true);
    setTimeout(() => {
      setItemsLoading(false);
    }, 2000);
  };

  useEffect(() => {
    if (itemDetailsData._id) {
      setItemsTab(itemDetailsData._id);
    } else {
      setItemsTab(itemTabName);
    }
    // setSelectedValue("Item Details")
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const selectedItemArray =
    itemHeadersTable.length > 0 && itemDetailsData
      ? itemHeadersTable.find((data) => data._id === itemDetailsData._id)
      : "";

  console.log(selectedItemArray, "selectedItemArray");
  console.log(itemDetailsData, "itemDetailsData");

  //Custom Fields State values
  const [customFields, setCustomFields] = useState(false);
  // const [customFieldsAdd, setCustomFieldsAdd] = useState(false);
  const [pageRender, setPageRender] = useState(false);

  const handleOk = () => {
    setCustomFields(false);
  };
  const handleCancel = () => {
    setCustomFields(false);
  };

  const [customFieldsData, setCustomFieldsData] = useState([
    {
      fieldName: "",
    },
  ]);

  const addCustomFields = () => {
    setCustomFieldsData([
      ...customFieldsData,
      {
        fieldName: "",
      },
    ]);
    // setCustomFieldsAdd(true);
    setPageRender(!pageRender);
  };

  const removeCustomFields = (index) => {
    const array = customFieldsData;
    if (index !== 0) {
      if (index > -1) {
        array.splice(index, 1);
      }
    }
    setPageRender(!pageRender);
  };

  const handleCustomFieldsChange = (e, name, index) => {
    var fieldList = customFieldsData;
    if (name === "fieldName") {
      fieldList[index][name] = e.target.value;
      setCustomFieldsData(fieldList);
      setPageRender(!pageRender);
    }
  };

  //adjust stock
  const [adjustStock, setAdjustStock] = useState(false);
  const [adjustStockValidations, setAdjustStockValidations] = useState(false);

  const [adjustStockData, setAdjustStockData] = useState({
    adjustQuantity: "",
    adjustRemarks: "",
    itemName: "",
    _id: "",
    stockQuantity: "",
  });

  const [adjustMode, setAdjustMode] = useState("");
  const [deletedItemId, setDeletedItemId] = useState("");
  const handleAdjustChange = (e) => {
    setAdjustStockData({
      ...adjustStockData,
      [e.target.name]: e.target.value,
    });
  };
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  //category api integrations
  const deleteItems = () => {
    setIsButtonDisabled(true);
    setTimeout(() => {
      setIsButtonDisabled(false);
    }, 4000);
    const itemList = {
      organizationId: userInfoDetails,
      itemId: !isEmpty(itemDetailsData)
        ? [itemDetailsData._id]
        : [itemData._id],
      deletedBy: !isEmpty(userNameDetails) ? userNameDetails.user._id : "",
    };

    setDeletedItemId(itemList.itemId[0]);
    api
      .post("/org/deleteitem", itemList)
      .then((res) => {
        dispatch(loadItems(itemList));
        setDeleteItemModal(false);
        toast.error("Items Deleted Successfully");
        setTimeout(() => {
          history.push("/items");
        }, 1200);
        return res.data;
      })
      .catch((error) => {
        const errorMsg =
          (error &&
            error.response &&
            error.response.data &&
            error.response.data.error) ||
          (error &&
            error.response &&
            error.response.data &&
            error.response.data.message);
        toast.error(errorMsg || "There is an issue while delete the items");
        Promise.reject(error);
      });
    // dispatch(deleteItemList(itemList));
  };

  const stockQuantity = parseFloat(adjustStockData.stockQuantity);
  const adjustQuantity = parseFloat(adjustStockData.adjustQuantity);

  const finalStock = stockQuantity + adjustQuantity;

  const finalStockReduceValue =
    adjustStockData.adjustQuantity &&
    adjustStockData.stockQuantity &&
    adjustMode === "Reduce"
      ? parseInt(adjustStockData.stockQuantity - adjustStockData.adjustQuantity)
      : adjustStockData.adjustQuantity &&
        isEmpty(adjustStockData.stockQuantity) &&
        adjustMode === "Reduce"
      ? stockQuantity
      : "";

  const finalStockAddValue =
    adjustStockData.adjustQuantity &&
    adjustStockData.stockQuantity &&
    adjustMode === "Add"
      ? finalStock
      : adjustStockData.adjustQuantity &&
        isEmpty(adjustStockData.stockQuantity) &&
        adjustMode === "Add"
      ? adjustQuantity
      : "";

  //items stock integrations
  const adjustStockDetails = () => {
    if (!isEmpty(adjustStockData.adjustQuantity)) {
      const stockList = {
        itemId: !isEmpty(itemDetailsData) ? itemDetailsData._id : itemData._id,
        organizationId: userInfoDetails,
        isAdd: adjustMode === "Add" ? true : false,
        isReduce: adjustMode === "Reduce" ? true : false,
        quantity: adjustStockData.adjustQuantity
          ? parseInt(adjustStockData.adjustQuantity)
          : 0,
      };

      dispatch(adjustStockList(stockList));
      setTimeout(() => {
        dispatch(loadItems(itemListId));
        setAdjustStock(false);
        setAdjustStockValidations(false);
        toast.success("Stock Adjusted successfully");
      }, 1000);
    } else {
      setAdjustStockValidations(true);
    }
  };

  //api loader
  useEffect(() => {
    if (itemCreated === true) {
      dispatch(loadItems(itemListId));
      setItemCreated(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemCreated]);

  useEffect(() => {
    if (!isEmpty(deletedItemId)) {
      const itemsFilteredData =
        itemHeadersTable.length > 0
          ? itemHeadersTable.filter((data) => data._id !== deletedItemId)
          : [];
      const partiesRemainingData =
        itemsFilteredData && itemsFilteredData.length > 0
          ? itemsFilteredData[0]
          : "";
      const partiesRemainingId =
        itemsFilteredData && itemsFilteredData.length > 0
          ? itemsFilteredData[0]._id
          : "";
      console.log(itemsFilteredData, partiesRemainingId, "partiesId");
      setItemsTab(partiesRemainingId);
      setItemsSelectedTabs(partiesRemainingData);
      setItemDetailsData(partiesRemainingData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deletedItemId]);

  return (
    <React.Fragment>
      <div className="">
        <MetaTags>
          <title>Items | Mbook</title>
        </MetaTags>
      </div>

      <Row className="border-solid rounded-sm bg-[#ffffff]">
        <Col span={24}>
          <Row>
            <Col span={5} className="border border-r-1 border-y-0 border-l-0">
              <Row className="flex justify-between mb-4 mt-4">
                <Col span={24} className="pr-3 pl-4">
                  <div className="flex">
                    <Tooltip
                      rootClassName="text-[10px]"
                      title="Search by phone or name"
                      placement="bottom"
                    >
                      <AutoComplete
                        style={{
                          width: 170,
                          marginRight: "10px",
                          fontFamily: "Poppins",
                        }}
                      >
                        <Input.Search
                          size="large"
                          placeholder="Search Items"
                          style={{
                            fontFamily: "Poppins",
                          }}
                          name="search"
                          value={search}
                          onChange={(e) => handleSearch(e)}
                        />
                      </AutoComplete>
                    </Tooltip>
                  </div>
                </Col>
                <Col
                  span={24}
                  // onMouseEnter={() => setMouseEnter(true)}
                  // onMouseLeave={() => setMouseEnter(false)}
                  className={"items-stocks-menu-main-card"}
                  // className={mouseEnter ? "items-stocks-menu-main-card" : ""}
                >
                  <Row className="pl-5 pr-5 mt-6 mb-5">
                    {itemRows.map((data) => {
                      return (
                        <Col span={24} key={data.key} className="mb-4">
                          {itemsLoading ? (
                            <Skeleton.Input
                              //   style={{
                              //     marginRight: "5px",
                              //   }}
                              active={true}
                              size={"large"}
                              // block={true}
                            ></Skeleton.Input>
                          ) : (
                            <div
                              className={
                                itemsTab === data._id
                                  ? "poppins parties-selection-card parties-selection-cards border rounded-md"
                                  : "poppins parties-selection-card border rounded-md"
                              }
                              onClick={() => {
                                setItemsTab(data._id);
                                setItemDetailsData(data);
                                setAdjustStockData({
                                  stockQuantity: data.stockQTY
                                    ? data.stockQTY
                                    : "",
                                });
                                // setItemsLoading(true);
                                // setTimeout(() => {
                                //   setItemsLoading(false);
                                // }, 2000);
                              }}
                            >
                              <div
                                style={{
                                  fontSize: "12px",
                                  display: "flex",
                                  color: "black",
                                }}
                              >
                                <h2>{data.itemName}</h2>
                              </div>
                              <div className="mt-1 flex justify-between">
                                <h1 className="font-semibold text-[14px]">
                                  ₹{" "}
                                  {data.salesPrice
                                    ? parseFloat(data.salesPrice)
                                        .toFixed(2)
                                        .toLocaleString("en-IN")
                                    : 0}
                                </h1>
                                <p>
                                  {data.mode === "debit" ? (
                                    <ArrowUpOutlined className="text-[red]" />
                                  ) : (
                                    <ArrowDownOutlined className="text-[green]" />
                                  )}
                                </p>
                              </div>
                            </div>
                          )}
                        </Col>
                      );
                    })}
                  </Row>
                </Col>
              </Row>
            </Col>
            <Col span={19}>
              <Row>
                <Col span={24}>
                  <div className="font-poppins flex justify-between pl-[20px] pr-[20px] mt-4">
                    <div className="flex">
                      <ArrowLeftOutlined
                        onClick={() => setPageRouting(true)}
                        className="font-bold text-[18px]"
                      />
                      <h1 className="text-[20px] ml-2 mt-2 font-semibold">
                        {!isEmpty(itemsTab) && itemDetailsData !== undefined
                          ? itemDetailsData.itemName
                          : ""}
                      </h1>
                    </div>

                    <div className="flex">
                      <Tooltip
                        title="Add or reduce your stock for this item"
                        placement="left"
                        rootClassName="text-[12px] cursor-not-allowed"
                      >
                        <div
                          onClick={() => {
                            setAdjustStock(true);
                            setAdjustStockData({
                              stockQuantity: itemDetailsData
                                ? itemDetailsData.stockQTY
                                : "",
                              itemName: itemDetailsData.itemName,
                            });
                          }}
                          style={{
                            pointerEvents: "none",
                            opacity: 2,
                            background: "#f3f3f3",
                          }}
                          className="border font-semibold flex items-selection-data rounded-md justify-between  pl-3 pr-3 pt-2 pb-2 ml-3  cursor-pointer"
                        >
                          <FileTextOutlined className="text-[14px] mr-2 mt-[-2px]" />{" "}
                          Adjust Stock
                        </div>
                      </Tooltip>
                      <Tooltip
                        title="Edit Item Details"
                        placement="left"
                        rootClassName="text-[10px]"
                      >
                        <div
                          onClick={() => setCreateItemModal(true)}
                          className="border flex rounded-md justify-between  pl-3 pr-2 pt-2 pb-2 ml-3  cursor-pointer"
                        >
                          <EditOutlined className="text-[16px] pr-3" /> Edit
                        </div>
                      </Tooltip>
                      <Tooltip
                        title="Delete This Item"
                        placement="bottom"
                        rootClassName="text-[10px]"
                      >
                        <div
                          onClick={() => setDeleteItemModal(true)}
                          className="border border-1 border-red-200 text-[red] rounded-md ml-3 p-2.5 cursor-pointer"
                        >
                          <DeleteOutlined />
                        </div>
                      </Tooltip>
                    </div>
                  </div>
                </Col>

                <Col span={24}>
                  <Row className="border border-b-1 border-t-0 border-x-0 flex flex-row ml-4 mr-4 pr-5 mt-6 mb-5">
                    {itemSelectTabs.map((data) => {
                      return (
                        <div
                          className={
                            itemsSelectedTabs === data.label
                              ? "p-2 font-semibold parties-selection-data-tabs parties-selection-tabs"
                              : "p-2 parties-selection-data-tabs"
                          }
                          key={data.key}
                          onClick={() => {
                            setItemsSelectedTabs(data.label);
                            setLoading(true);
                            setTimeout(() => {
                              setLoading(false);
                            }, 2000);
                          }}
                        >
                          <div
                            style={{
                              fontSize: "13px",
                              display: "flex",
                              color:
                                itemsSelectedTabs === data.label
                                  ? "#8400ff"
                                  : "#667085",
                            }}
                          >
                            <p className={data.key !== 1 ? "mt-[1px]" : ""}>
                              {data.icon}
                            </p>
                            <h2 className={"ml-2"}>{data.label}</h2>
                          </div>
                        </div>
                      );
                    })}
                  </Row>
                  <Row
                    className={
                      // itemsSelectedTabs === "Transactions" ||
                      // itemsSelectedTabs === "Ledger (Statement)"
                      // ? "pl-4 pr-4"
                      "pl-4 pr-4"
                    }
                  >
                    {itemsSelectedTabs === "Stock Details" ? (
                      <Transactions
                        itemId={
                          !isEmpty(itemDetailsData) ? itemDetailsData._id : ""
                          // : itemData._id
                        }
                        organizationId={userInfoDetails}
                      />
                    ) : itemsSelectedTabs === "Party Wise Report" ? (
                      <ItemWiseReport
                        itemId={
                          !isEmpty(itemDetailsData) ? itemDetailsData._id : ""
                          // : itemData._id
                        }
                        organizationId={userInfoDetails}
                      />
                    ) : (
                      // Profile Details
                      <Col span={24}>
                        <Row>
                          <Col span={12} className="pr-4">
                            <Row className="mb-4 border rounded-md border-1 border-lightgray-200">
                              <Col
                                span={24}
                                className="border border-b-1 border-x-0 border-t-0 "
                              >
                                <div className="p-2 bg-[#e5e5e5] party-label">
                                  <p className="text-[12px]">
                                    <FileTextOutlined className="mr-3" />
                                    General Details
                                  </p>
                                </div>
                              </Col>
                              {loading ? (
                                <Skeleton
                                  style={{
                                    marginRight: "5px",
                                    width: "100%",
                                    height: "250px",
                                    padding: "10px",
                                  }}
                                  active={true}
                                  size={"large"}
                                  // block={true}
                                ></Skeleton>
                              ) : (
                                <>
                                  <Col span={24} className="pb-2 pl-4 pr-4">
                                    <div className="party-label mt-2">
                                      <h1 className="mb-1">Item Name</h1>
                                      <p className="font-semibold">
                                        {selectedItemArray &&
                                        selectedItemArray.itemName !== undefined
                                          ? selectedItemArray.itemName &&
                                            selectedItemArray.itemName
                                          : // itemData
                                          // ? itemData.itemName &&
                                          //   itemData.itemName.toLocaleString()
                                          // :
                                          itemDetailsData
                                          ? itemDetailsData.itemName &&
                                            itemDetailsData.itemName
                                          : itemsTab
                                          ? itemsTab
                                          : "Item Details"}
                                      </p>
                                    </div>
                                  </Col>
                                  <Col span={12} className="pb-2 pl-4 pr-4">
                                    <div className="party-label mt-2">
                                      <h1 className="mb-1">Item Code</h1>
                                      <p className="font-semibold">
                                        {
                                          // itemData && isEmpty(itemDetailsData)
                                          //   ? itemData.itemCode
                                          //   :
                                          // !isEmpty(selectedItemArray) &&
                                          // selectedItemArray.itemCode !=
                                          //   undefined
                                          //   ? selectedItemArray.itemCode
                                          //   :
                                          itemDetailsData !== undefined &&
                                          itemDetailsData.itemCode &&
                                          itemDetailsData.itemCode != undefined
                                            ? itemDetailsData.itemCode
                                            : "--"
                                        }
                                      </p>
                                    </div>
                                  </Col>
                                  <Col span={12} className="pl-4 pr-4">
                                    <div className="party-label mt-2">
                                      <h1 className="mb-1">Brand</h1>
                                      <p className="font-semibold">
                                        {
                                          // itemData && isEmpty(itemDetailsData)
                                          //   ? itemData.brandName
                                          //   :
                                          !isEmpty(selectedItemArray) &&
                                          selectedItemArray.brandName !==
                                            undefined
                                            ? selectedItemArray.brandName
                                            : itemDetailsData !== undefined
                                            ? itemDetailsData.brandName
                                            : // : itemData && isEmpty(itemDetailsData)
                                            // ? itemData.categoryName
                                            !isEmpty(selectedItemArray) &&
                                              selectedItemArray.categoryName !==
                                                undefined
                                            ? selectedItemArray.categoryName
                                            : itemDetailsData
                                            ? itemDetailsData.categoryName
                                            : "--"
                                        }
                                      </p>
                                    </div>
                                  </Col>
                                  <Col span={12} className="pl-4 pr-4">
                                    <div className="party-label  mt-2">
                                      <h1 className="mb-1">Current Stock</h1>
                                      <p className="font-semibold">
                                        {
                                          // itemData && isEmpty(itemDetailsData)
                                          //   ? itemData.noofStock
                                          //   :
                                          !isEmpty(selectedItemArray) &&
                                          selectedItemArray.stockQTY !==
                                            undefined
                                            ? selectedItemArray.stockQTY
                                            : itemDetailsData !== undefined
                                            ? itemDetailsData.stockQTY
                                            : "--"
                                        }
                                      </p>
                                    </div>
                                  </Col>
                                  <Col span={24} className="pl-4 pr-4 pb-4">
                                    <div className="party-label  mt-2">
                                      <h1 className="mb-1">
                                        Low Stock Warning
                                      </h1>
                                      <p className="font-semibold text-[#d94141]">
                                        Disabled
                                      </p>
                                    </div>
                                  </Col>
                                  <Col span={24} className="pl-4 pr-4 pb-4">
                                    <div className="party-label  mt-2">
                                      <h1 className="mb-1">Item Description</h1>
                                      <p className="font-semibold">
                                        {
                                          // itemData && isEmpty(itemDetailsData)
                                          //   ? itemData.description
                                          //   :
                                          !isEmpty(selectedItemArray)
                                            ? selectedItemArray.description
                                            : itemDetailsData !== undefined
                                            ? itemDetailsData.description
                                            : "--"
                                        }
                                      </p>
                                    </div>
                                  </Col>
                                </>
                              )}
                            </Row>
                          </Col>
                          <CreateItems
                            // recordsMetaData={recordsMetaData}
                            modalOpen={createItemModal}
                            itemCreated={handleItemCreate}
                            modalClose={handleClose}
                            mode="Update"
                            updatedItemValues={updatedItemList}
                            data={
                              !isEmpty(selectedItemArray)
                                ? selectedItemArray
                                : itemDetailsData !== undefined
                                ? itemDetailsData
                                : // : !isEmpty(itemData)
                                  // ? itemData
                                  ""
                            }
                          />
                          <Col span={12} className="">
                            {" "}
                            <Row className="mb-2 border rounded-md border-1 border-lightgray-200">
                              <Col
                                span={24}
                                className="border border-b-1 border-x-0 border-t-0 "
                              >
                                <div className="p-2 bg-[#e5e5e5] party-label">
                                  <p className="text-[12px] flex">
                                    <FcMoneyTransfer
                                      size={14}
                                      className="mr-3"
                                    />
                                    Pricing Details
                                  </p>
                                </div>
                              </Col>
                              {loading ? (
                                <Skeleton
                                  style={{
                                    marginRight: "5px",
                                    width: "100%",
                                    height: "170px",
                                    padding: "10px",
                                  }}
                                  active={true}
                                  size={"large"}
                                  // block={true}
                                ></Skeleton>
                              ) : (
                                <>
                                  <Col span={12} className="pb-4 pl-4 pr-4">
                                    <div className="party-label mt-2">
                                      <h1 className="mb-1">Sales Price</h1>
                                      <p className="font-semibold flex">
                                        ₹{" "}
                                        {selectedItemArray &&
                                        selectedItemArray.salesPrice !==
                                          undefined
                                          ? selectedItemArray.salesPrice &&
                                            selectedItemArray.salesPrice.toLocaleString()
                                          : itemDetailsData !== undefined
                                          ? itemDetailsData.salesPrice &&
                                            itemDetailsData.salesPrice.toLocaleString()
                                          : "--"}
                                        <p className="font-medium ml-1 mt-0.5 text-[#a9adb1] text-[10px]">
                                          With Tax
                                        </p>
                                      </p>
                                    </div>
                                  </Col>
                                  <Col span={12} className="pb-4 pl-4 pr-4">
                                    <div className="party-label mt-2">
                                      <h1 className="mb-1">Purchase Price</h1>
                                      <p className="font-semibold flex">
                                        ₹{" "}
                                        {selectedItemArray &&
                                        selectedItemArray.purchasePrice !==
                                          undefined
                                          ? selectedItemArray.purchasePrice &&
                                            selectedItemArray.purchasePrice.toLocaleString()
                                          : itemDetailsData !== undefined
                                          ? itemDetailsData.purchasePrice &&
                                            itemDetailsData.purchasePrice.toLocaleString()
                                          : "--"}
                                        <p className="font-medium ml-1 mt-0.5 text-[#a9adb1] text-[10px]">
                                          With Tax
                                        </p>
                                      </p>
                                    </div>
                                  </Col>

                                  <Col span={8} className="pl-4 pr-4">
                                    <div className="party-label  mt-2">
                                      <h1 className="mb-1">HSN Code</h1>
                                      <p className="font-semibold">
                                        {
                                          // itemData && isEmpty(itemDetailsData)
                                          //   ? itemData.HSNCode
                                          //   :
                                          !isEmpty(selectedItemArray)
                                            ? selectedItemArray.HSNCode
                                            : itemDetailsData !== undefined
                                            ? itemDetailsData.HSNCode
                                            : "--"
                                        }
                                      </p>
                                    </div>
                                  </Col>
                                  <Col span={8} className="pl-4 pr-4 pb-4">
                                    <div className="party-label  mt-2">
                                      <h1 className="mb-1">GST Tax Rate</h1>
                                      <p className="font-semibold">
                                        {
                                          // itemData && isEmpty(itemDetailsData)
                                          //   ? itemData.gstPercentageName
                                          //   :
                                          !isEmpty(selectedItemArray)
                                            ? selectedItemArray.gstPercentageName
                                            : itemDetailsData !== undefined
                                            ? itemDetailsData.gstPercentageName
                                            : "--"
                                        }
                                      </p>
                                    </div>
                                  </Col>
                                  <Col span={8} className="pl-4 pr-4 pb-4">
                                    <div className="party-label  mt-2">
                                      <h1 className="mb-1">Secondary Unit</h1>
                                      <p className="font-semibold">
                                        {
                                          // itemData && isEmpty(itemDetailsData)
                                          //   ? itemData.serialMeasuringName
                                          //   :
                                          !isEmpty(selectedItemArray)
                                            ? selectedItemArray.serialMeasuringName
                                            : itemDetailsData !== undefined
                                            ? itemDetailsData.serialMeasuringName
                                            : "--"
                                        }
                                      </p>
                                    </div>
                                  </Col>
                                </>
                              )}
                            </Row>
                          </Col>
                        </Row>
                      </Col>
                    )}
                  </Row>
                </Col>
              </Row>
            </Col>

            {/* Parties input section with bulk actions */}
          </Row>
        </Col>
      </Row>

      {/* Adjust Stock Quantity modal */}
      <Modal
        open={adjustStock}
        title="Adjust Stock Quantity"
        onOk={() => {
          adjustStockDetails();
        }}
        closeIcon
        maskClosable={false}
        okText={"Save"}
        width={450}
        className="mt-[-95px]"
        onCancel={() => setAdjustStock(false)}
        footer={(_, { OkBtn, CancelBtn }) => (
          <>
            <CancelBtn />
            <OkBtn />
          </>
        )}
      >
        <Divider
          style={{ borderWidth: "0.2px", width: "112%", marginLeft: "-24px" }}
        />

        <Row className="mt-[-10px] mb-[-18px]">
          <Col span={24} className="mb-2">
            <Typography className="mb-1 items-label">Item Name</Typography>
            <h1 className="text-[14px] font-semibold">
              {adjustStockData.itemName}
            </h1>
          </Col>
          <Col span={24} className="mb-2 mt-2">
            <Typography className="mb-2 items-label">
              Add Or Reduce Quantity
            </Typography>

            <Radio.Group
              className="w-[100%]"
              value={adjustMode}
              onChange={(e) => setAdjustMode(e.target.value)}
            >
              <Radio
                style={{
                  fontFamily: "Poppins",
                }}
                value={"Add"}
                className="w-[45%]"
              >
                Add +
              </Radio>
              <Radio
                value={"Reduce"}
                style={{
                  fontFamily: "Poppins",
                }}
                className="w-[45%] ml-2 p-3 rounded-md border border-1"
              >
                Reduce -
              </Radio>
            </Radio.Group>
          </Col>
          <Col span={24} className="mb-2">
            <Typography className="mb-2 items-label">
              Current Stock Level
            </Typography>
            <h1 className="text-[13px]">
              {adjustStockData.stockQuantity
                ? adjustStockData.stockQuantity
                : 0}
            </h1>
          </Col>

          <Col span={24} className="mb-2 pr-2">
            <Typography className="mb-2 items-label">
              Adjust Quantity
            </Typography>
            <Input
              name="adjustQuantity"
              value={adjustStockData.adjustQuantity}
              placeholder="0.0"
              onChange={(e) => handleAdjustChange(e)}
              className="p-2"
              suffix={"PCS"}
            />
            <p className="text-start text-[red] mt-2 mb-3">
              {adjustStockValidations === true
                ? "Adjust Quantity field is required"
                : ""}
            </p>
          </Col>
          <Col span={24} className="mb-2 mt-2 ">
            <Typography className="mb-2 items-label">Final Stocks</Typography>
            <h1 className="text-[13px]">
              {isNaN(finalStockAddValue) || isNaN(finalStockReduceValue)
                ? stockQuantity
                : adjustMode === "Reduce"
                ? finalStockReduceValue
                : adjustMode === "Add"
                ? finalStockAddValue
                : 0}
            </h1>
          </Col>
          <Col span={24} className="mt-2 ">
            <Typography className="mb-2 items-label">Remarks</Typography>
            <Input.TextArea
              name="adjustRemarks"
              value={adjustStockData.adjustRemarks}
              placeholder="Enter Remarks"
              onChange={(e) => handleAdjustChange(e)}
              className="p-2"
              suffix={"PCS"}
            />
          </Col>
        </Row>

        <Divider
          style={{ borderWidth: "0.2px", width: "112%", marginLeft: "-24px" }}
        />
      </Modal>

      {/* Custom fields modal */}
      <Modal
        open={customFields}
        title="Add Custom Fields"
        onOk={handleOk}
        closeIcon
        maskClosable={false}
        okText={"Save"}
        okButtonProps={{
          disabled: customFieldsData.length > 0 ? false : true,
        }}
        onCancel={handleCancel}
        footer={(_, { OkBtn, CancelBtn }) => (
          <>
            <CancelBtn />
            <OkBtn />
          </>
        )}
      >
        <Divider
          style={{ borderWidth: "0.2px", width: "110%", marginLeft: "-24px" }}
        />
        <div className="w-[110%] ml-[-23.5px] mt-[-24px] mb-4">
          <Image src={customModalLogo} />
        </div>
        <div>
          <Typography className="mb-2">Field Name</Typography>
          {customFieldsData.map((data, index) => {
            return (
              <div key={index} className="mb-2">
                <div className="flex justify-between mb-[10px]">
                  <Input
                    name="fieldName"
                    value={data.fieldName}
                    placeholder="Enter Custom Field name"
                    className="w-[90%]"
                    onChange={(e) =>
                      handleCustomFieldsChange(e, "fieldName", index)
                    }
                  />
                  <DeleteOutlined
                    onClick={() => removeCustomFields(index)}
                    type="primary"
                    className="ml-3 border rounded-md p-2 text-[red] cursor-pointer"
                    size={"large"}
                  />{" "}
                </div>
              </div>
            );
          })}
        </div>
        {/* ) : (
            ""
          )} */}

        <Row
          onClick={() => addCustomFields()}
          className="w-[100%] mt-2 bg-gray-50 p-2 border border-dashed border-blue-400 pl-5 pr-5 mt-3 mb-3"
        >
          <h1 className="cursor-pointer text-[14px] text-[#084d7b] font-semibold">
            {" "}
            <PlusOutlined /> Add Custom Field
          </h1>
        </Row>
        <Divider
          style={{ borderWidth: "0.2px", width: "110%", marginLeft: "-24px" }}
        />
      </Modal>

      {/* Delete item modal */}

      <Modal
        open={deleteItemModal}
        onOk={() => {
          deleteItems();
        }}
        closeIcon
        maskClosable={false}
        okText={`Delete Item`}
        cancelText={"Cancel"}
        okType="danger"
        okButtonProps={{
          disabled: isButtonDisabled ? true : false,
        }}
        onCancel={() => setDeleteItemModal(false)}
        height={300}
        footer={(_, { OkBtn, CancelBtn }) => (
          <div className="text-center flex justify-center">
            <CancelBtn />
            <div className="ml-3">
              <OkBtn />
            </div>
          </div>
        )}
      >
        <div className="text-center w-[100%] p-7">
          <ExclamationCircleOutlined className="mb-2 text-center text-[#f1c40f] font-bold text-[44px]" />
          <h1 className="text-center text-[18px] font-bold">
            Are you sure you want to delete these Items?
          </h1>
          <p className="text-center text-[14px] mt-2">
            The selected Items will be deleted from the Items Inventory. Once
            deleted you will not be able to restore these items.
          </p>
        </div>
      </Modal>
      <Modal
        open={pageRouting}
        onOk={() => {
          setPageRouting(false);
          history.push("/items");
        }}
        closeIcon
        maskClosable={false}
        rootClassName="p-15 h-[300px]"
        okText={"Yes, Leave"}
        cancelText={"No, Stay"}
        onCancel={() => setPageRouting(false)}
        footer={(_, { OkBtn, CancelBtn }) => (
          <div className="text-center flex justify-center">
            <div className="mr-3">
              <OkBtn />
            </div>
            <CancelBtn />
          </div>
        )}
        width={500}
      >
        <div className="text-center w-[100%]">
          <ExclamationCircleOutlined className="mb-2 text-center text-[#f1c40f] font-bold text-[44px]" />
          <h1 className="text-center text-[18px] font-bold">
            Are you sure you want to leave this page?
          </h1>
          <p className="text-center text-[14px] mt-2">
            All unsaved changes will be lost!
          </p>
        </div>
      </Modal>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        // closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        // tog
        style={{
          fontSize: "12px",
        }}
        // pauseOnHover
        theme="dark"
      />
    </React.Fragment>
  );
};

ItemsSelection.propTypes = {
  location: PropTypes.any,
};

export default ItemsSelection;
